import { render, staticRenderFns } from "./UploadPhotos.vue?vue&type=template&id=30db0c68&"
import script from "./UploadPhotos.vue?vue&type=script&lang=js&"
export * from "./UploadPhotos.vue?vue&type=script&lang=js&"
import style0 from "./UploadPhotos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports